var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("span", {
    staticClass: "mask-icon flex-shrink-0",
    style: _setup.iconStyle,
    attrs: { "data-qa": "mask_icon" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }